import React from "react";
import { title, bodyText } from './Constants/index.js';
import { Title, Subtitle } from 'src/Common/Theme/Typography/index';

const TextContent = () => {
  return (
    <div className="home-page-intro">
      <div className="title-wrapper">
        <Title shopee bold className="title">{title}</Title>
      </div>
      <div className="body-text-wrapper">
        <Subtitle openSans className="body-text">{bodyText}</Subtitle>
      </div>
    </div>
  )
}

export default TextContent;